import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-906a8668")
const _hoisted_1 = {
  key: 0,
  class: "_toggle"
}
const _hoisted_2 = { class: "burger" }
const _hoisted_3 = { class: "_content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_NavigationItem = _resolveComponent("NavigationItem")!
  const _component_NavigationMeta = _resolveComponent("NavigationMeta")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
    navigation:true,
    open: _ctx.open
  })
  }, [
    (!_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_IconButton, {
              icon: "burger",
              white: true,
              type: "svg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open')))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((
        _ctx.$route.path.includes('/app/game')?[]:
        _ctx.$route.path.includes('/developer')?_ctx.DevRoutes: 
        _ctx.Routes), (route) => {
        return (_openBlock(), _createBlock(_component_NavigationItem, {
          route: route,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, null, 8, ["route"]))
      }), 256)),
      _hoisted_4,
      (!_ctx.$route.path.includes('/app/game'))
        ? (_openBlock(), _createBlock(_component_NavigationMeta, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}